// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"1992":"3db10426","2296":"c657780e","6711":"0c92b273"}[chunkId] + ".chunk.css";
};